export default __webpack_public_path__ + "static/media/Roboto-Bold.8d9d887f.eot";